import React from 'react'
import { Icon } from '@lightspeed/design-system-react'

interface InputErrorProps {
  errorElement: React.JSX.Element
}

// Wrapper component for displaying error messages related to line item input fields
export const InputErrorMessage: React.FC<InputErrorProps> = ({
  errorElement,
}) => {
  return (
    <div className="wr-input-messages wr-media">
      <Icon
        icon="fa-exclamation-triangle"
        className="wr-media-object"
        data-cy="fa-exclamation-triangle"
      />
      <div className="wr-media-body">{errorElement}</div>
    </div>
  )
}
